import React from "react";
import { ProgressBar, Stack, Text } from "@shopify/polaris";

export default function ProgressIndicator(props) {
  const usedText = props.usedText || "used";
  const numberWithCommas = (x) =>
    x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const usedAsPercent = props.used / props.of;
  const color = props.color
    ? props.color
    : props.used >= props.of
    ? "critical"
    : "primary";
  return (
    <div>
      <Stack distribution="equalSpacing" alignment="center">
        <Text variant="headingXs" as="h3">{props.title}</Text>
        <Text  variant="bodyMd" as="span" color="subdued">
          {numberWithCommas(props.used)}of{numberWithCommas(props.of)}{" "}
          {props.suffix || ""} {usedText}
        </Text>
      </Stack>
      <div style={{ marginTop: "0.2em" }}>
        <ProgressBar
          progress={usedAsPercent * 100}
          color={color}
          size={props.size}
        />
      </div>
    </div>
  );
}
